import React, { useContext, useState } from "react";
import {
  DriveEta,
  MonetizationOn,
  HighlightOff,
  ExitToApp,
} from "@material-ui/icons";
import axios from "axios";
import Swal from "sweetalert2";
import { Context } from "../../context/Context";

const Status = ({ reservation, card }) => {
  const [isCarClicked, setIsCarClicked] = useState(false);
  const [isMoneyClicked, setIsMoneyClicked] = useState(false);
  const [isCheckClicked, setIsCheckClicked] = useState(false);
  const { user, token } = useContext(Context);

  const handleGarageStatus = () => {
    if (!reservation.hasArrived) {
      Swal.fire({
        title: "Samochód przyjechał na parking?",
        showCancelButton: true,
        confirmButtonText: "Potwierdzam",
        confirmButtonColor: "#1267a2",
        denyButtonColor: "gray",
        cancelButtonText: "Anuluj",
      })
        .then((result) => {
          if (result.isConfirmed) {
            const changeArrived = async () => {
              try {
                await axios.put(
                  `https://www.rezerwacjaparkingu.com/backend_artlot/api/reservations/${reservation._id}`,
                  {
                    hasArrived: true,
                  },
                  {
                    headers: {
                      authorization: "megaparkingIGHERQHIGQRE " + token,
                    },
                  }
                );
              } catch (err) {
                console.log(err);
              }
            };
            changeArrived();
          }
        })
        .then(() => {
          Swal.fire({
            title: "Zapisano",
            icon: "success",
            confirmButtonText: `Ok`,
            confirmButtonColor: "#1267a2",
            denyButtonColor: "gray",
          }).then((res) => {
            if (res.isConfirmed) {
              window.location.reload();
            }
          });
        });
    }
  };

  const handleStatus = (
    text,
    element,
    buttonText,
    check,
    set,
    term,
    condition
  ) => {
    if (!check && !term) {
      Swal.fire({
        title: text,
        showDenyButton: true,
        confirmButtonText: buttonText,
        confirmButtonColor: "#1267a2",
        denyButtonColor: "gray",
        denyButtonText: `Anuluj`,
      }).then((result) => {
        if (result.isConfirmed) {
          const change = async () => {
            try {
              await axios.put(
                `https://www.rezerwacjaparkingu.com/backend_artlot/api/reservations/${reservation._id}`,
                element,
                {
                  headers: {
                    authorization: "megaparkingIGHERQHIGQRE " + token,
                  },
                }
              );
              Swal.fire({
                title: "Zapisano",
                icon: "success",
                confirmButtonText: `Ok`,
                confirmButtonColor: "#1267a2",
              }).then((result) => {
                if (result.isConfirmed) {
                  if (text !== "Samochód przyjechał na parking?") {
                    window.location.reload();
                  } else {
                    setIsCarClicked(true);
                  }
                }
              });
            } catch (err) {
              console.log(err);
            }
            if (condition === "done") {
              try {
                Swal.fire({
                  title: "Zapisano",
                  icon: "success",
                  confirmButtonText: `Ok`,
                  confirmButtonColor: "#1267a2",
                }).then((result) => {
                  if (result.isConfirmed) {
                    if (text !== "Samochód przyjechał na parking?") {
                      window.location.reload();
                    } else {
                      setIsCarClicked(true);
                    }
                  }
                });
              } catch (err) {
                console.log(err);
              }
            }
          };
          change();
        }
      });
    }
  };
  const handleStatusDelete = () => {
    Swal.fire({
      title: "Usunąć rezerwacje?",
      showDenyButton: true,
      confirmButtonText: `Potwierdzam`,
      confirmButtonColor: "#1267a2",
      denyButtonColor: "gray",
      denyButtonText: `Anuluj`,
    }).then((result) => {
      if (result.isConfirmed) {
        const change = async () => {
          try {
            await axios.put(
              `https://www.rezerwacjaparkingu.com/backend_artlot/api/reservations/${reservation._id}`,
              {
                till: "",
                reservationId: "",
                isTaken: false,
              },
              {
                headers: {
                  authorization: "megaparkingIGHERQHIGQRE " + token,
                },
              }
            );
            await axios.delete(
              `https://www.rezerwacjaparkingu.com/backend_artlot/api/reservations/${reservation._id}`,
              {
                headers: {
                  authorization: "megaparkingIGHERQHIGQRE " + token,
                },
              }
            );
          } catch (err) {
            console.log(err);
          }
        };
        change();
        Swal.fire({
          title: "Zapisano",
          icon: "success",
          confirmButtonText: `Ok`,
          confirmButtonColor: "#1267a2",
        }).then((result) => {
          if (result.isConfirmed) {
            window.location.reload();
          }
        });
      }
    });
  };
  let carStyle;
  if (reservation.hasArrived || isCarClicked) {
    carStyle = { color: "rgb(79, 136, 211)" };
    if (reservation.garage) {
      carStyle = {
        color: "rgb(79, 136, 211)",
        border: "1px solid rgb(79, 136, 211)",
        borderRadius: "5px",
      };
    }
  } else {
    if (reservation.garage) {
      carStyle = {
        border: "1px solid rgb(138, 138, 138)",
        borderRadius: "5px",
      };
    }
  }
  return (
    <div className="statusData">
      {user.role === "admin" ? (
        <>
          <DriveEta
            className={card ? "carCard" : "car"}
            style={carStyle}
            onClick={handleGarageStatus}
          />
          <MonetizationOn
            className={card ? "moneyCard" : "money"}
            style={
              reservation.isPaid || isMoneyClicked
                ? { color: "rgb(5, 192, 105)" }
                : {}
            }
            onClick={() =>
              handleStatus(
                `Do zapłaty ${reservation.price}zł`,
                {
                  isPaid: true,
                },
                "Zapłacono",
                isMoneyClicked,
                setIsMoneyClicked,
                reservation.isPaid
              )
            }
          />
          <ExitToApp
            className={card ? "checkCard" : "check"}
            style={
              reservation.isDone || isCheckClicked
                ? { color: "rgb(5, 192, 105)" }
                : {}
            }
            onClick={() =>
              handleStatus(
                "Transakcja zakończona?",
                {
                  isDone: true,
                },
                "Potwierdzam",
                isCheckClicked,
                setIsCheckClicked,
                reservation.isDone,
                "done"
              )
            }
          />
        </>
      ) : null}
      <HighlightOff
        className={card ? "deleteCard" : "delete"}
        onClick={handleStatusDelete}
      />
    </div>
  );
};

export default Status;
